import { createSelector } from 'reselect';

const selectPaymentStatus = (state: any) => state.paymentStatus;

export const selectPaymentStatusCurrentItem = createSelector([selectPaymentStatus], (paymentStatus) => paymentStatus.current);

export const selectPaymentStatusListItems = createSelector([selectPaymentStatus], (paymentStatus) => paymentStatus.list);


export const selectPaymentStatusItemById = (itemId: any) =>
    createSelector(selectPaymentStatusListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPaymentStatusQueryItems = createSelector([selectPaymentStatus], (paymentStatus) => paymentStatus.query);

export const selectPaymentStatusCreatedItem = createSelector([selectPaymentStatus], (paymentStatus) => paymentStatus.create);

export const selectPaymentStatusUpdatedItem = createSelector([selectPaymentStatus], (paymentStatus) => paymentStatus.update);

export const selectPaymentStatusReadItem = createSelector([selectPaymentStatus], (paymentStatus) => paymentStatus.read);

export const selectPaymentStatusDeletedItem = createSelector([selectPaymentStatus], (paymentStatus) => paymentStatus.delete);

export const selectPaymentStatusSearchedItems = createSelector([selectPaymentStatus], (paymentStatus) => paymentStatus.search);

export const selectPaymentStatusItemsCount = createSelector([selectPaymentStatus], (paymentStatus) => paymentStatus.count);

export const selectPaymentStatusItemsFilter = createSelector([selectPaymentStatus], (paymentStatus) => paymentStatus.filter);